import React, { useMemo } from "react";
import KC_Text from "../../../../designsystem/typography/KC_Text/KC_Text";
import {
  KC_Sizes,
  KC_Text_Sizes,
  KC_Weights
} from "../../../../designsystem/ds_commons";
import MobilePreview from "../../../../components/MobilePreview/MobilePreview";
import CONFIG from "../../../../model/TSConfig";
import { LogoConfigurator } from "../../../../components/SaasGameConfiguration/LogoConfigurator";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";
import ColorsSelector from "../../../../components/SaasGameConfiguration/components/ColorsSelector";
import "./styles.scss";
import {
  updateJetpackConfigThunk,
  useJetpackConfigSelector
} from "../../../../redux/jetpackConfig";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";
import { tt } from "../../../../utils/i18n/i18n";
import { useDispatch } from "react-redux";
import { setError } from "../../../../redux/actions/app";
import KC_Separator from "../../../../designsystem/KC_Separator/KC_Separator";

import MobileDashboardHeader from "../../../Layout/Mobile/MobileDashboardHeader";
import { DEFAULT_GAME_COLORS } from "../../../../utils/constants";
import KC_Heading2 from "../../../../designsystem/typography/KC-Heading/KC_Heading2";

export default function LogoAndColorsEditor() {
  const dispatch = useDispatch();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const jetpackConfig = useJetpackConfigSelector();

  const iframeGameURL = useMemo(() => {
    return `${CONFIG.jetpackFrontendUrl}/?v=${accountToDisplay?.trackingID}&pre=true`;
  }, [accountToDisplay]);

  const onJetpackColorChange = async (key: string, hexColor: string) => {
    if (!accountToDisplay?.trackingID) {
      return;
    }

    if (!key || !hexColor || !jetpackConfig) {
      return;
    }

    if (
      hexColor ===
      jetpackConfig?.colors?.[key as keyof typeof jetpackConfig.colors]
    ) {
      return;
    }

    try {
      const colors = jetpackConfig?.colors ?? DEFAULT_GAME_COLORS;
      const newColors = {
        ...colors,
        [key]: hexColor
      };
      const isUpdateCustomer = true;

      void dispatch(
        updateJetpackConfigThunk(
          { colors: newColors },
          accountToDisplay.trackingID,
          accountToDisplay?.token,
          isUpdateCustomer
        )
      );
    } catch (e) {
      dispatch(setError(tt("api_update_color_error")));
    }
  };

  return (
    <div className="logo-editor dashboard-v2">
      <MobileDashboardHeader
        title={tt("saas_game_configuration_logo_and_colors_heading")}
        description={tt("saas_game_configuration_logo_and_colors_subheading")}
      />
      <div
        id="logo-editor-title"
        className="w-100 d-flex flex-sm-grow-1 px-4 pt-5 gap-xl justify-content-start border-bottom"
      >
        <div className="d-none d-xl-flex flex-column flex-sm-grow-1">
          <KC_Heading2
            text={tt("saas_game_configuration_logo_and_colors_heading")}
          />
          <KC_Text
            size={KC_Text_Sizes.lg}
            weight={KC_Weights.reg}
            text={tt("saas_game_configuration_logo_and_colors_subheading")}
            className={"text-secondary"}
          />
        </div>
      </div>
      <div className="d-flex logo-editor-child">
        <div className="w-100 px-4 flex-sm-grow-1 ">
          <div
            className="w-100 d-flex align-items-center justify-content-between"
            style={{ minHeight: 120 }}
          >
            <LogoConfigurator
              isPOSA={false}
              onChanged={(key: string, color: string) => {
                if (!accountToDisplay) {
                  return;
                }
                const newColors = {
                  ...(jetpackConfig?.colors ?? DEFAULT_GAME_COLORS),
                  [key]: color
                };
                dispatch(
                  updateJetpackConfigThunk(
                    { colors: newColors },
                    accountToDisplay.trackingID,
                    accountToDisplay?.token
                  )
                );
              }}
            />
          </div>
          <div>
            <ColorsSelector
              isPOSA={false}
              onColorChanged={onJetpackColorChange}
              primary={jetpackConfig?.colors?.primary}
              accent={jetpackConfig?.colors?.accent}
              background={jetpackConfig?.colors?.background}
              titles={jetpackConfig?.colors?.titles}
            />
          </div>
        </div>
        <div
          className="flex-column py-4 border-left d-none d-md-flex"
          style={{ paddingLeft: 40, paddingRight: 40, gap: 21 }}
        >
          <KC_Heading3
            text={tt("saas_game_configuration_game_preview_label")}
          />
          <MobilePreview iframeGameURL={iframeGameURL} />
        </div>
      </div>

      <div className="d-block d-md-none px-4">
        <KC_Separator size={KC_Sizes.reg} />
        <MobilePreview iframeGameURL={iframeGameURL} />
        <KC_Separator size={KC_Sizes.xl} />
      </div>
    </div>
  );
}
